import * as React from 'react';
import { useSelector } from 'react-redux';

import { MortgageBankTemplate } from '../../../components/adfox/templates/MortgageAside/MortgageBankTemplate';
import { MortgageAsideTemplate } from '../../../components/adfox/templates/MortgageAside/MortgageTemplate';
import { TAdFoxTemplatesParams } from '../../../components/adfox/templates/OwnTemplates';
import { isOfferInGageSelector, selectTrackingPage, selectTrackingUser } from '../../../selectors';
import { trackAdFoxMortgage } from '../../../tracking/ad-fox-mortgage';

export const AsideMortgageBannerTemplateContainer: React.VFC<TAdFoxTemplatesParams> = props => {
  const isInGage = useSelector(isOfferInGageSelector);
  const page = useSelector(selectTrackingPage);
  const user = useSelector(selectTrackingUser);

  const onClick = React.useCallback(() => {
    trackAdFoxMortgage('click', 'BannerIpoteka', props.bannerId, user, page);
  }, [props.bannerId, user, page]);

  React.useEffect(() => {
    trackAdFoxMortgage('show', 'BannerIpoteka', props.bannerId, user, page);
  }, []);

  if (isInGage) {
    return null;
  }

  if (Number.parseInt(props.isBank, 10)) {
    return (
      <MortgageBankTemplate
        onClick={onClick}
        bannerId={props.bannerId}
        image={props.image}
        title={props.title}
        label={props.label}
        url={props.url}
        description={props.description}
        annotation={props.annotation}
      />
    );
  }

  return (
    <MortgageAsideTemplate
      onClick={onClick}
      bannerId={props.bannerId}
      image={props.image}
      title={props.title}
      label={props.label}
      url={props.url}
      description={props.description}
      annotation={props.annotation}
    />
  );
};
